import { render, staticRenderFns } from "./NotificationsEvList.vue?vue&type=template&id=17fdb462"
import script from "./NotificationsEvList.vue?vue&type=script&lang=js"
export * from "./NotificationsEvList.vue?vue&type=script&lang=js"
import style0 from "./NotificationsEvList.vue?vue&type=style&index=0&id=17fdb462&prod&soped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports